/**
 * Test IDs used across the app - keep names stable & unique.
 */
export const TESTIDS = {
  landing: {
    root: "landing-root",
    emailInput: "landing-email-input",
    submitBtn: "landing-continue-btn",
  },
  login: {
    root: "login-root",
    passwordInput: "login-password-input",
    submitBtn: "login-submit-btn",
    forgotLink: "login-forgot-link",
  },
  createPassword: {
    root: "create-password-root",
    passwordInput: "create-password-input",
    confirmInput: "create-password-confirm",
    submitBtn: "create-password-submit",
  },
  forgot: {
    root: "forgot-root",
    emailInput: "forgot-email-input",
    submitBtn: "forgot-submit-btn",
  },
  reset: {
    root: "reset-root",
    passwordInput: "reset-password-input",
    submitBtn: "reset-submit-btn",
  },
  dashboard: {
    root: "dashboard-root",
    newDiagnosticBtn: "new-diagnostic-btn",
    diagnosticRow: "diagnostic-row",
    downloadPdfBtn: "download-pdf-btn",
    compareBtn: "compare-btn",
    logoutBtn: "logout-btn",
  },
  diagnostic: {
    root: "diagnostic-root",
    startBtn: "diagnostic-start-btn",
    nextBtn: "diagnostic-next-btn",
    prevBtn: "diagnostic-prev-btn",
    submitBtn: "diagnostic-submit-btn",
    option: "diagnostic-option",
    progressBar: "diagnostic-progress",
  },
  results: {
    root: "results-root",
    overallScore: "results-overall-score",
    radar: "results-radar",
    downloadPdfBtn: "results-download-pdf",
  },
  compare: {
    root: "compare-root",
  },
  admin: {
    root: "admin-root",
    userRow: "admin-user-row",
  },
};

export const HOME = { emergentLink: "emergent-link" };
